import CustomAutocompleteWithListButtons from "@/components/Form/CustomAutocompleteWithListButtons";
import { useBeeswaxList } from "@/modules/BeeswaxList/beeswaxList.hook";
import { listTypeList } from "@/modules/BeeswaxList/data";
import {
  SubModule,
  SubModuleCommonProps,
} from "@/modules/Presets/TargetingExpression/targetingExpression.interface";
import { formateDataForCustomSelect } from "@/utils/helpers";
import AddRoundedIcon from "@mui/icons-material/AddRounded";
import { Box } from "@mui/material";
import { FieldValues } from "react-hook-form";
const moduleName = "app_site";
export default function AppSite<
  T extends FieldValues,
  U extends SubModule = "APP_SITE"
>({
  control,
  errors,
  setValue,
  getValues,
  handleCreateCustomList,
  handleEditCustomList,
  parentName,
  domainList,
  domainListLoading,
  dealList,
  dealListLoading,
  isEdit,
}: AppSiteProps<T, U>) {
  const {
    data: localDomainList,
    isLoading: localDomainListLoading,
    isFetching: localDomainListFetching,
  } = useBeeswaxList(
    {
      queryParams: { type: "domain" },
      options: { enabled: !domainList && !domainListLoading },
    },
    "withType"
  );
  const {
    data: localDealList,
    isLoading: localDealListLoading,
    isFetching: localDealListFetching,
  } = useBeeswaxList(
    {
      queryParams: { type: "deal_id" },
      options: { enabled: !dealList && !dealListLoading },
    },
    "withType"
  );
  domainList = isEdit && domainList ? domainList : localDomainList;
  domainListLoading =
    isEdit && domainListLoading
      ? domainListLoading
      : localDomainListLoading && localDomainListFetching;
  dealList = isEdit && dealList ? dealList : localDealList;
  dealListLoading =
    isEdit && dealList
      ? dealListLoading
      : localDealListLoading && localDealListFetching;

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: 2,
        height: "100%",
        overflow: "auto",
        padding: 2,
      }}
    >
      <Box sx={{ flexShrink: 0 }}>
        <CustomAutocompleteWithListButtons
          primaryName={`${parentName}.${moduleName}.deal_id_list.value.included`}
          secondaryName={`${parentName}.${moduleName}.deal_id_list.value.excluded`}
          itemList={formateDataForCustomSelect(dealList?.results, "name", "id")}
          handleEdit={handleEditCustomList}
          parentControl={control}
          label={"Deal List"}
          extraLabelButtons={[
            {
              icon: AddRoundedIcon,
              handleOnClick: () =>
                handleCreateCustomList(
                  listTypeList.find(
                    (listItem) => listItem.componentKey === "deal"
                  )?.value
                ),
              toolTipText: "Add",
            },
          ]}
          loading={dealListLoading}
        />
      </Box>
      <Box sx={{ flexShrink: 0 }}>
        <CustomAutocompleteWithListButtons
          primaryName={`${parentName}.${moduleName}.domain_list.value.included`}
          secondaryName={`${parentName}.${moduleName}.domain_list.value.excluded`}
          itemList={formateDataForCustomSelect(
            domainList?.results,
            "name",
            "id"
          )}
          handleEdit={handleEditCustomList}
          parentControl={control}
          label={"Domain List"}
          toolTip={`To target domains, you must first create a "domain list". To create a domain list click on the "+New" button, select the "List" option and then select "Domain List" as the list type. Once your domain list is created it will appear here for you to target.`}
          extraLabelButtons={[
            {
              icon: AddRoundedIcon,
              handleOnClick: () =>
                handleCreateCustomList(
                  listTypeList.find(
                    (listItem) => listItem.componentKey === "domain"
                  )?.value
                ),
              toolTipText: "Add",
            },
          ]}
          loading={domainListLoading}
        />
      </Box>
    </Box>
  );
}

type AppSiteProps<T extends FieldValues, U> = U extends "APP_SITE"
  ? AppSite<T>
  : never;
interface AppSite<T extends FieldValues> extends SubModuleCommonProps<T> {
  domainList: any;
  dealList: any;
  domainListLoading: boolean;
  dealListLoading: boolean;
}
